// extracted by mini-css-extract-plugin
export default {"total-percent":"CustomerCategoryAddForm_total-percent__E9RkS"};